import React from 'react';
import { Typography } from 'antd';
import type { DestinationAwareness } from './dispatcherContextProjection';

const { Text } = Typography;

type Props = {
  destination: DestinationAwareness | null;
};

export const DestinationAwarenessPanel: React.FC<Props> = ({ destination }) => {
  if (!destination) return null;

  const party =
    destination.kind === 'unloading'
      ? destination.consigneeName ?? destination.clientName
      : destination.clientName ?? destination.consigneeName;

  return (
    <section className="execution-workspace__destination">
      <div className="execution-workspace__section-title">Следующая точка</div>
      <div className="execution-workspace__destination-main">{destination.stopLabel}</div>
      {destination.address ? (
        <div className="execution-workspace__destination-line">{destination.address}</div>
      ) : (
        <Text className="execution-workspace__muted">Адрес не указан</Text>
      )}
      {party ? <div className="execution-workspace__destination-party">{party}</div> : null}
      {destination.applicationNumber ? (
        <Text className="execution-workspace__muted" style={{ fontSize: 11 }}>
          Заявка №{destination.applicationNumber}
        </Text>
      ) : null}
    </section>
  );
};

export default DestinationAwarenessPanel;
